import * as React from 'react';
class RenderEditor extends React.Component {
    render() {
        const { propertyOptions, propertyKey, serverUrl, source } = this.props;
        if (propertyOptions.editorComponent) {
            return (React.createElement(propertyOptions.editorComponent, { source: source, serverUrl: serverUrl, propertyOptions: propertyOptions, propertyKey: propertyKey, value: this.props.value, setValue: this.props.setValue }));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    }
}
export default RenderEditor;
